'use es6';

import http from 'hub-http/clients/apiClient';
/**
 * GET  designmanager/v1/layouts?template_type=18
 */

export function fetchSummaries(query = {}) {
  return http.get('designmanager/v1/layouts/global-groups/summaries', {
    query
  });
}